export default {
  addPayment: 'addPayment',
  milestoneActions: 'milestoneActions',
  useCredits: 'useCredits',
  pdf: 'pdf',
};
